import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { flow, defaultTo, get, includes } from 'lodash/fp';
import ItemSelector from './ItemSelector';
import addItemToSelection from '../../../actions/copyStyles/addItemToSelection';
import removeItemFromSelection from '../../../actions/copyStyles/removeItemFromSelection';
import { getAttributeValueOr, getAttributeValue } from '../../../helpers/getAttributeValue';
import validateItems from '../../../actions/copyStyles/validateItems';

const getItemDetails = itemProduct => (
  itemProduct && {
    color: getAttributeValueOr('Not selected', 'color', itemProduct),
    windowName: getAttributeValue('window name', itemProduct),
    brand: get('brand', itemProduct),
    productName: get('productName', itemProduct),
  }
);

const mapStateToProps = ({ estimateBuilder }, { sourceItemId, itemId }) => {
  const item = get(`entities.items.byId.${itemId}`, estimateBuilder);
  const label = get('label', item);

  const selection = get('copyStyles.selection', estimateBuilder);
  const isSelected = includes(itemId, selection);

  const details = getItemDetails(get('itemProduct', item));
  const sourceItem = get(`entities.items.byId.${sourceItemId}`, estimateBuilder);

  const validation = get(`copyStyles.validationResults.${itemId}`, estimateBuilder);

  return {
    itemName: flow(
      get('windowName'),
      defaultTo(label),
    )(details),
    isSelected,
    details,
    validation,
    sourceItem,
    newWindowLabel: get('windowLabel', estimateBuilder),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    addItemToSelection,
    removeItemFromSelection,
    validateItems,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemSelector);
